<div class="flex jsutify-content-center">
	<div class="flex justify-content-start flex-wrap gap-1">
		<div *ngFor="let e of api.editors" class="">
			<a [routerLink]='["/pages/"+e.id_editor_ebp+(this.api.export ? "-export" : "")]' class="block" style="max-width: 160px; max-height: 160px;">
				<img pTooltip="{{e.name}}" tooltipPosition="top" class="cursor-pointer"
					src="https://blackrockgames.fr/upload/editor/350_{{e.logo}}"
					style="max-width: 160px; max-height: 160px;">
			</a>
		</div>
	</div>
</div>